import { combineReducers } from 'redux'

import bid from './bid'
import list from './list'
import single from './single'

export default combineReducers({ list, single, bid })



// WEBPACK FOOTER //
// ./src/store/reducers/lots/index.js